import React from 'react'
import PropTypes from 'prop-types'
import './Loader.scss'

function Loader({ size = 'medium', className = '' }) {
  return (
    <div className={`loader-container ${className}`}>
      <div className={`loader loader-${size}`}></div>
    </div>
  )
}

Loader.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
}

export default Loader

